import { Directive, TemplateRef } from '@angular/core';

/**
 * Structural Directive to get a reference to the template/DOM.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[navPillsItem]',
})
export class NavPillsItemDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
